import React from "react";

const jobCategories = [
    { name: "Clinical Medicine" },
    { name: "Medical Education" },
    { name: "Medical communication" },
    { name: "Pharmaceuticals" },
    { name: "Clinical research" },
    { name: "HealthTech" },
    { name: "Business consulting" },
    { name: "Entrepreneurship" },
    { name: "Policy/legal/ethics" },
    { name: "Marketing/Sales" },
    { name: "Creative" },
    { name: "Wellness/lifestyle" },
];

const slugify = (name = "") =>
    name
        .toLowerCase()
        .replace(/\s+|\//g, "-")
        .replace(/[^a-z0-9-]/g, "");

const MatchIndustrySection = () => {
    const rows = [
        jobCategories.slice(0, 6),
        jobCategories.slice(6, 12),
    ];

    return (
        <section className="bg-white py-16" style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}>
            <div className="container mx-auto px-4 sm:px-6 lg:px-10 text-center">
                <style>{`
                    @media (max-width: 768px) {
                        .employer-match-industry-heading {
                            font-size: 24px !important;
                        }
                    }
                `}</style>
                <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-10 employer-match-industry-heading">
                    Match in your industry
                </h2>
                <div className="flex flex-col gap-4 items-center">
                    {rows.map((row, rowIndex) => (
                        <div key={`row-${rowIndex}`} className="flex flex-wrap justify-center gap-3 md:gap-4">
                            {row.map((category) => (
                                <span
                                    key={category.name}
                                    className={`category-pill ${slugify(category.name)}`}
                                    style={{ cursor: "default", pointerEvents: "none" }}
                                >
                                    {category.name}
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MatchIndustrySection;

